import React, { useContext } from 'react';
import cn from 'classnames';
import { NotificationsContext } from '../../context/Notifications.context';
import { MdClose } from 'react-icons/md';
import PropTypes from 'prop-types';
import styles from './NotificationLabel.module.scss';

const NotificationLabel = props => {
  const [notificationState, dispatchNotification] = useContext(NotificationsContext);

  const handleRemove = () => {
    dispatchNotification({
      type: 'REMOVE_NOTIFICATION',
      id: props.id
    });
  };

  return (
    <div id={props.id} className={cn(styles.container, props.className, {
      [styles.error]: props.type === 'error'
    })} onClick={props.onClick}>
      {props.text}
      <MdClose className={styles.close}
        onClick={handleRemove}
      />
    </div>
  );
};

NotificationLabel.propTypes = {
  text: PropTypes.any,
  className: PropTypes.any,
  onClick: PropTypes.any,
  type: PropTypes.any,
  id: PropTypes.any
};

export default NotificationLabel;
